import {CommonModule}                      from '@angular/common';
import {HTTP_INTERCEPTORS}                 from '@angular/common/http';
import {NgModule}                          from '@angular/core';
import {MatDatepickerModule}               from '@angular/material/datepicker';
import {MatProgressSpinnerModule}          from '@angular/material/progress-spinner';
import {MatStepperModule}                  from '@angular/material/stepper';
import {ProductsIndexComponent}            from '@src/app/admin/products/components/index/products-index.component';
import {PricingModalComponent}             from '@src/app/admin/products/components/pricing-modal/pricing-modal.component';
import {ProductsRoutingModule}             from '@src/app/admin/products/products-routing.module';
import {SettingsModule}                    from '@src/app/admin/settings/settings.module';
import {AuthInterceptor}                   from '@src/app/core/interceptors/auth-interceptor';
import {AdminModule}                       from '@src/app/layout/admin/admin.module';
import {AdditionalPriceTierModalComponent} from './components/additional-price-tier-modal/additional-price-tier-modal.component';
import {DeletePriceTierModalComponent}     from './components/delete-price-tier-modal/delete-price-tier-modal.component';
import {EditPriceTierModalComponent}       from './components/edit-price-tier-modal/edit-price-tier-modal.component';
import {ProductsFormComponent}             from './components/form/products-form.component';
import {CustomProductsComponent}           from './components/index/custom-products/custom-products.component';
import {DefaultProductsComponent}          from './components/index/default-products/default-products.component';
import {PriceUploadModalComponent}         from './components/price-upload-modal/price-upload-modal.component';
import {PricingViewComponent}              from './components/pricing-view/pricing-view.component';

@NgModule({
    imports: [
        ProductsRoutingModule,
        AdminModule,
        CommonModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        SettingsModule,
        MatStepperModule,
    ],
    declarations: [
        ProductsIndexComponent,
        DefaultProductsComponent,
        CustomProductsComponent,
        ProductsFormComponent,
        PricingModalComponent,
        PriceUploadModalComponent,
        PricingViewComponent,
        EditPriceTierModalComponent,
        AdditionalPriceTierModalComponent,
        DeletePriceTierModalComponent
    ],
    exports: [
        ProductsIndexComponent,
        DefaultProductsComponent,
        CustomProductsComponent,
        ProductsFormComponent,
        PricingViewComponent,
        EditPriceTierModalComponent,
        AdditionalPriceTierModalComponent,
        DeletePriceTierModalComponent
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    ]
})
export class ProductsModule
{
}
